import React, { useState } from "react";
import toast from "react-hot-toast";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import Footer from "../../components/Footer/Footer";
import Button from "../../components/Utils/Button/Button";
import { StyledInputEmail } from "../../components/Utils/StyledInput/StyledInput";
import useLoadingStore from "../../stores/LoadingStore";
import appFetch from "../../Utils/Services/Fetch/appFetch";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { loadingStates, setLoading } = useLoadingStore();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      setLoading("forgotPassword", true);
      const response = await appFetch(
        "/api/auth/forgotPassword",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        },
        navigate,
      );

      if (response) {
        navigate("/");
        toast.success(response.message);
      }
      setLoading("forgotPassword", false);
    } catch (error) {
      console.error("Error:", error);
      setLoading("forgotPassword", false);
    }
  };

  return (
    <div className="loginRoot">
      <div className="loginPage">
        <Button
          icon={<FaArrowLeft />}
          onClick={() => navigate("/")}
          style="square"
        />
        <form onSubmit={handleSubmit}>
          <StyledInputEmail
            label="Email"
            value={email}
            setValue={setEmail}
            required={true}
            className="inputLogin"
          />

          <Button
            type="submit"
            label={"Reinitialiser le mot de passe"}
            className="loginSubmitButton"
            isLoading={loadingStates.forgotPassword}
          />
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
